import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import Header from "../../components/HomePage/header";
import Footer from "../../components/HomePage/footer";
import Breadcrumbs from "./Breadcrum";
import ArticleHeader from "./ArticleHeader";
import Content from "./Content";
import BottomCtaModule from "./BottomCtaModule";
import PostTags from "./PostTags";
import AuthorBox from "./AutherBox";
import PostNavigation from "./PostNavigation";
import RelatedPosts from "./RelatedPosts";
import SidebarSubscribe from "./SidebarSubscribe";
import SidebarRelatedPosts from "./SidebarRelatedPosts";
import FloatingCtaModule from "./FloatingCtaModule";
import NewsletterPopup from "../../Account/NewsletterPopup";
import { Helmet } from "react-helmet";


export default function BlogPostPage() {
  const { link } = useParams(); // Use useParams to extract 'link' from the URL
  const [post, setPost] = useState(null);
  const [latestPosts, setLatestPosts] = useState([]);
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [newsPosts, setNewsPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPosts = async (params, setState) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await fetch(`/api/posts?${queryParams}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch posts: ${response.statusText}`);
      }
      const data = await response.json();
      setState(data.posts);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    // Fetch individual post by link
    const fetchPost = async () => {
      try {
        const response = await fetch(`/api/posts/${link}`); // Use the 'link' from the URL
        if (response.ok) {
          const data = await response.json();
          setPost(data); // Set the fetched post data
        } else {
          throw new Error("Post not found");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();

    fetchPosts(
      {
        status: "published",
        sortBy: "createdAt",
        order: "desc",
        limit: 5,
        page: 1,
      },
      setLatestPosts
    );

    // Fetch featured posts
    fetchPosts(
      {
        status: "published",
        category: "Featured",
        sortBy: "createdAt",
        order: "desc",
        limit: 5,
        page: 1,
      },
      setFeaturedPosts
    );

    // Fetch news posts
    fetchPosts(
      {
        status: "published",
        category: "News",
        sortBy: "createdAt",
        order: "desc",
        limit: 5,
        page: 1,
      },
      setNewsPosts
    );
  }, [link]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  console.log("Post Data :",post)

  return (
    <>
        <Helmet>
        <title>{post.title}</title>
        <meta
          name="description"
          content={post.description}
        />
        <meta
          name="keywords"
          content={Array.isArray(post.keywords) ? post.keywords.join(', ') : post.keywords}
        />
      </Helmet>
      <Header />
      {/* Sidebar positioned at the top-right corner, hidden on small screens */}
      <div className="w-full lg:w-1/4 p-4 mt-6 lg:mt-0 ml-auto absolute top-28 right-20 hidden lg:block">
        <SidebarSubscribe />
        <SidebarRelatedPosts posts={latestPosts} featuredPosts={featuredPosts}  />{" "}
        {/* Pass related posts to the Sidebar */}
        <FloatingCtaModule />
      </div>
      <Breadcrumbs post={post}/>
      <ArticleHeader post={post} /> {/* Pass post data to the ArticleHeader */}
      <Content post={post} /> {/* Pass post data to the Content */}
 
      <BottomCtaModule />
      <PostTags post={post} /> {/* Pass post data to the PostTags */}
      <AuthorBox post={post} /> {/* Pass post data to the AuthorBox */}
      {/* <PostNavigation post={post} />{" "} */}
      {/* Pass post data to the PostNavigation */}
      <RelatedPosts posts={latestPosts} authorPosts={featuredPosts} />{" "}
      {/* Pass related posts to the RelatedPosts */}
      <NewsletterPopup />
      <Footer />
    </>
  );
}
